import { Chip, type ChipProps } from '@circlefin/components/lib/Chip'
import { useDate } from '@circlefin/hooks'

export interface StatusWithDateProps {
  /**
   * The status to be displayed.
   */
  status: string
  /**
   * The chip variant used for the status.
   */
  chipVariant: ChipProps['variant']
  /**
   * The date associated with the status.
   */
  date: string | Date
}

export const StatusWithDate: React.FC<StatusWithDateProps> = ({
  status,
  chipVariant,
  date,
}) => {
  const { date: formatDate } = useDate()

  return (
    <div className="flex flex-col">
      <Chip variant={chipVariant}>
        <p className="type-body-base-bold">{status}</p>
      </Chip>
      <p className="type-body-xs">
        {formatDate(date, 'dateTimeWithYearAndTimeZone', 'UTC')}
      </p>
    </div>
  )
}
